(() => {
  const lazyWidgets = document.querySelectorAll('[data-judge-me-lazy]:not([data-lazy-bound])');

  if (!lazyWidgets.length) return;

  const waitForJudgeMeLoader = () =>
    new Promise((resolve, reject) => {
      const startedAt = Date.now();

      const check = () => {
        const loader = [...document.scripts].find(
          (script) =>
            script.src.includes('/judgeme-') &&
            script.src.includes('/assets/loader.js') &&
            !script.hasAttribute('data-judge-me-lazy-reload')
        );

        if (loader && window.jdgm?._loaderExecuted) {
          resolve(loader.src);
          return;
        }

        if (Date.now() - startedAt > 5000) {
          reject(new Error('Judge.me core loader was not available.'));
          return;
        }

        window.setTimeout(check, 50);
      };

      check();
    });

  const executeTemplateScripts = async (fragment) => {
    const scripts = [...fragment.querySelectorAll('script')];
    scripts.forEach((script) => script.remove());

    for (const sourceScript of scripts) {
      await new Promise((resolve) => {
        const script = document.createElement('script');

        [...sourceScript.attributes].forEach(({ name, value }) => {
          script.setAttribute(name, value);
        });

        if (sourceScript.src) {
          script.addEventListener('load', resolve, { once: true });
          script.addEventListener('error', resolve, { once: true });
          script.src = sourceScript.src;
        } else {
          script.textContent = sourceScript.textContent;
        }

        document.body.appendChild(script);

        if (!sourceScript.src) resolve();
      });
    }
  };

  const reloadJudgeMe = async () => {
    const loaderSrc = await waitForJudgeMeLoader();

    await new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = loaderSrc;
      script.type = 'text/javascript';
      script.async = true;
      script.setAttribute('data-judge-me-lazy-reload', '');
      script.addEventListener('load', resolve, { once: true });
      script.addEventListener('error', () => reject(new Error('Judge.me widget loader failed.')), {
        once: true,
      });

      window.jdgm._loaderExecuted = false;
      document.body.appendChild(script);
    });
  };

  const hydrateWidget = (container) => {
    if (container.dataset.loading === 'true' || container.dataset.loaded === 'true') return;

    container.dataset.loading = 'true';

    window.__judgeMeLazyQueue = (window.__judgeMeLazyQueue || Promise.resolve())
      .then(async () => {
        const template = container.querySelector('[data-judge-me-lazy-template]');
        const target = container.querySelector('[data-judge-me-lazy-target]');

        if (!template || !target) throw new Error('Judge.me lazy widget markup is incomplete.');

        const fragment = template.content.cloneNode(true);
        target.remove();
        template.replaceWith(fragment);
        await executeTemplateScripts(container);
        await reloadJudgeMe();

        container.dataset.loaded = 'true';
        container.removeAttribute('data-loading');
        container.setAttribute('aria-busy', 'false');

        if (window.location.hash === '#judgeme_product_reviews') {
          document.querySelector('#judgeme_product_reviews')?.scrollIntoView({ block: 'start' });
        }
      })
      .catch((error) => {
        container.removeAttribute('data-loading');
        container.setAttribute('aria-busy', 'false');
        console.error('[Judge.me lazy widget]', error);
      });
  };

  const observer =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          (entries, activeObserver) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;

              activeObserver.unobserve(entry.target);
              hydrateWidget(entry.target);
            });
          },
          { rootMargin: '600px 0px' }
        )
      : null;

  lazyWidgets.forEach((container) => {
    container.dataset.lazyBound = 'true';

    if (window.location.hash === '#judgeme_product_reviews' || !observer) {
      hydrateWidget(container);
    } else {
      observer.observe(container);
    }
  });
})();
